module.exports = __webpack_public_path__ + "static/media/whatsapp3.b30492e9.png";